import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const contactUsReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_CONTACT_US:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_CONTACT_US_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_CONTACT_US_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_CONTACT_US:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default contactUsReducer;